import {ID} from '../../../../../../_metronic/helpers'
import {FieldProps} from '../../../../../../_component/Form'
export type PaymentSetting = {
  id?: ID
  interswitch_merchant_code: string
  interswitch_pay_item_id: string
  status?: boolean
}

export const fields: FieldProps[] = [
  {
    name: 'interswitch_merchant_code',
    label: 'Interswitch Merchant Code',
    helpText:
      'You can get this from your  <a href="https://business.quickteller.com/developertools" target="_blank" rel="noreferrer">Interswitch account dashboard</a>.',
  },
  {
    name: 'interswitch_pay_item_id',
    label: 'Interswitch Pay Item ID',
    helpText:
      'You can get this from your  <a href="https://business.quickteller.com/developertools" target="_blank" rel="noreferrer">Interswitch account dashboard</a>.',
  },
]
export const importProps = {status: true}
